// @flow
import { saveAuthData, removeAuthData } from '../module/auth/middleware'

export const middleware = [
  saveAuthData,
  removeAuthData,
]
